import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Otp from 'react-otp-input';
import { Trans } from '@lingui/macro';
import styles from './GoId.css';
import AccountAssociationModal from './AccountAssociationModal';

class GoId extends React.Component {
  state = {
    otp: '',
    errorMessage: '',
    associationModalClosed: false,
  };

  handleOtpChange = otp => {
    this.setState({
      otp,
    });

    if (otp.length === 6) {
      const { onNext } = this.props;
      setTimeout(() => onNext(otp));
    }
  };

  handleSubmit = e => {
    e.preventDefault();
  };

  handleAssociationModalClose = () => {
    this.setState({
      associationModalClosed: true,
    });
  };

  render() {
    const { loginId, isNewlyAssociated, onReset, appName } = this.props;
    const { otp, errorMessage, associationModalClosed } = this.state;
    const displayAssociationModal =
      isNewlyAssociated && !associationModalClosed;

    return (
      <div>
        {displayAssociationModal && (
          <AccountAssociationModal onClose={this.handleAssociationModalClose} />
        )}

        <div className={classNames('text-info', styles.infoBar)}>
          <div className="container">
            <i className="glyphicon glyphicon-info-sign" />
            &nbsp;
            <Trans>Your account has been associated with GoBiz.</Trans>
          </div>
        </div>

        <div className={styles.formContainer}>
          <div className={styles.header}>
            {appName ? (
              <div className={styles.titleOpenPlatform}>
                <Trans>
                  Sign in to use <strong>{appName}</strong>
                </Trans>
              </div>
            ) : (
              <div className={styles.title}>
                <Trans>Sign In</Trans>
              </div>
            )}

            <div className={styles.loginIdPreview}>
              <span className={styles.loginIdPreviewText}>{loginId}</span>
              <a className={styles.loginIdPreviewChangeLink} onClick={onReset}>
                <Trans>Change</Trans>
              </a>
            </div>

            <div className={styles.instruction}>
              <Trans>
                Enter the verification code we just sent to this number
              </Trans>
            </div>
          </div>

          <form onSubmit={this.handleSubmit}>
            <div
              className={classNames('form-group', {
                'has-error': errorMessage,
              })}
            >
              <Otp
                value={otp}
                onChange={this.handleOtpChange}
                numInputs={6}
                shouldAutoFocus
                hasErrored={!!errorMessage}
                containerStyle={{
                  justifyContent: 'space-between',
                  marginBottom: '10px',
                }}
                inputStyle={{
                  borderWidth: 0,
                  borderBottom: '1px solid #000',
                  height: '34px',
                  width: '24px',
                  color: '#2e2e2e',
                  fontWeight: 'bold',
                }}
                errorStyle={{
                  borderBottomColor: '#ea3546',
                }}
              />
              {errorMessage && (
                <div className="text-danger text-center">
                  <Trans id={errorMessage} />
                </div>
              )}
            </div>
          </form>

          <div className={styles.footer}>
            <Trans>
              <span>Didn’t receive a code?</span> <a href="#">Resend</a>
            </Trans>
          </div>
        </div>
      </div>
    );
  }
}

GoId.defaultProps = {
  loginId: '',
  appName: '',
  onReset: () => {},
  onNext: () => {},
  isNewlyAssociated: false,
};

function mapStateToProps(state) {
  const { isNewlyAssociated } = state.login;
  return {
    isNewlyAssociated,
  };
}

export default connect(mapStateToProps)(GoId);
